import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useRef, useState } from "react";
import { fetchVolunteers } from "store/volunteers/volunteers.actions";
import {
  ProfileVolunteerHeader,
  ProfileVolunteersContainer,
  ProfileVolunteerSpotlight
} from "../VolunteerSpotlight/Volunteer.styles";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { StatusState } from "store/types";
import VolunteerCard from "./VolunteerCard";

export default function VolunteerSpotlight() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const dispatch = useAppDispatch();
  const { data: volunteers, status } = useAppSelector((state) => state.volunteers);
  const toggleExpand = () => {
    if (volunteers.length > 3) {
      setExpanded(!expanded); // Expand only on 3+ elements
    }
  };

  useEffect(() => {
    if (status === StatusState.IDLE) {
      dispatch(fetchVolunteers());
    }
  }, [status, dispatch]);

  return (
    <ProfileVolunteerSpotlight
      style={{ position: "relative" }}
      className={expanded ? "expanded" : "collapsed"}
    >
      <ProfileVolunteerHeader>
        <h2>Volunteer Spotlight</h2>
        <a href="#!" onClick={toggleExpand} className="view-more">
          {expanded ? (
            <>
              View Less <ExpandLessIcon />
            </>
          ) : (
            <>
              View More <ExpandMoreIcon />
            </>
          )}
        </a>
      </ProfileVolunteerHeader>
      <ProfileVolunteersContainer
        className={expanded ? "expanded" : "collapsed"}
      >
        {volunteers.map((volunteer, index) => (
          <VolunteerCard key={index} {...volunteer} />
        ))}
      </ProfileVolunteersContainer>
    </ProfileVolunteerSpotlight>
  );
}
